export default Slider;

import AjaxRequest from './Ajax';

const $ = jQuery;

function Slider(config) {
    var $placeholder = $(config.domElements.placeholder);
    var selector = {owlCarousel: '.owl-carousel-v2'};
    var formatSettings = {
        BackgroundColorState: 0,
        ColNum: 1,
        ColumnMargin: 10,
        ContentDisplay: "1",
        ContentSize: "ww_lg",
        RowNumMax: "1",
        SmartRowFill: "0",
        article_categories_ContentPartDisplay: "0",
        article_excerpt_ContentPartDisplay: "0",
        article_title_ContentPartDisplay: "1"
    };
    var responsiveGrid = {
        "0": {
            items: 1,
            nav: true
        },
        "360": {
            items: 1,
            nav: true
        },
        "540": {
            items: 1,
            nav: true
        },
        "724": {
            items: 2,
            nav: true
        },
        "940": {
            items: 3,
            nav: true
        },
        "1180": {
            items: 4,
            nav: true,
            loop: false
        },
        "1420": {
            items: 4,
            nav: true,
            loop: false
        }
    };
    var content_size_grid_matrix = {
        grids: ["0", "360", "540", "724", "940", "1180", "1420"],
        ww_sm: [1, 2, 3, 4, 5, 7, 7],
        ww_md: [1, 1, 2, 3, 4, 5, 5],
        ww_lg: [1, 1, 1, 2, 3, 4, 4]
    };
    var side_content_size_grid_matrix = {
        grids: ["0", "360", "540", "724", "940", "1180", "1420"],
        ww_sm: [1, 1, 2, 3, 4, 4, 4],
        ww_md: [1, 1, 2, 2, 2, 3, 3],
        ww_lg: [1, 1, 1, 1, 1, 2, 2]
    };
    var $carousel;
    var itemsPerSlide,
        containerWidth,
        ColumnsPerSlide,
        RowNumMax,
        ContentSize,
        SmartRowFill,
        SlideNum,
        $parent,
        $items;

    init();

    function init() {
        getData(result => {
            var template = Handlebars.compile($(config.templates.slider).html());
            var html = template({
                title: config.title,
                data: result,
                sliderType: config.sliderType,
                actualDate: moment(Date.now()).format("YYYY-MM-DD")
            });
            $placeholder.append(html);
            format();
        });
    }

    function getData(callback) {
        var request = {
            url: config.ajaxUrl + "/" + config.ajaxAction,
            data: {
                "action": config.ajaxAction,
                "slider_type": config.sliderType
            },
            success: function (response) {
                if (response.success && response.data !== null) {
                    formatResponseData(response.data.items, (formattedResponse) => {
                        callback(formattedResponse);
                    });
                }
            }
        };
        if (config.sliderType === 'fix') {
            $.extend(request.data, {identifier_list: JSON.stringify(config.identifierList.split(';'))});
        } else {
            var newObjectList = [];
            config.objectTypeList.forEach((item) => {
                if(item !== "corporate"){
                    newObjectList.push(item);
                }
            });
            $.extend(request.data, {
                max_count: config.maxCount,
                object_type_list: JSON.stringify(newObjectList)
            });
        }
        AjaxRequest(request);
    }

    function formatResponseData(feed, callback) {
        feed.forEach((item, index) => {
            $.each(config.pages, (pageIndex, page) => {
                if (pageIndex.includes(item.objectType)) {
                    $.extend(feed[index], {page: page});
                }
            });
            if(item.objectType === "geo"){
                item.parentList.reverse();
            }
        });
        callback(feed);
    }

    function format() {
        $parent = $($(config.domElements.placeholder)).find(selector.owlCarousel);
        $items = $parent.find(" > .article_item");
        ContentSize = formatSettings.ContentSize || "ww_md";

        /* check side content */
        if ([4, 5].indexOf(parseInt(formatSettings.ContentDisplay)) >= 0) {
            content_size_grid_matrix = side_content_size_grid_matrix;
        }
        if (!content_size_grid_matrix.hasOwnProperty(ContentSize)) {
            ContentSize = "ww_md";
        }

        markItems();
        refreshMatrix();
        refreshResponsiveGridByContentSize(ContentSize);
    }

    function markItems() {
        if (!$parent.data("calc-marked")) {
            $items.each(function (index, item) {
                $(item).attr("data-calc-pos", index);
            });
            $parent.data("calc-marked", true)
        }
    }

    function refreshMatrix() {
        containerWidth = $parent.parent().outerWidth();
        ColumnsPerSlide = getGridCol(ContentSize, containerWidth);
        RowNumMax = formatSettings && formatSettings.RowNumMax ? formatSettings.RowNumMax : 1;
        SmartRowFill = formatSettings && formatSettings.SmartRowFill ? formatSettings.SmartRowFill : 0;
        SlideNum = parseInt($items.length / RowNumMax);
        if (SlideNum < $items.length / RowNumMax) SlideNum++;

        if (RowNumMax > 1) {
            itemsPerSlide = RowNumMax * ColumnsPerSlide;
            SlideNum = parseInt($items.length / itemsPerSlide);
            if (SlideNum < $items.length / itemsPerSlide) SlideNum++;

            for (var i = 0; i < SlideNum; i++) {
                if ($parent.find(".help-col[data-pos='" + i + "']").length == 0) {
                    $col = $('<div class="help-col" data-pos="' + i + '"></div>');
                    $parent.append($col);
                }
            }

            //slide bejárás
            for (var i = 0; i * itemsPerSlide < $items.length; i++) {
                var $col = $parent.find(".help-col[data-pos='" + i + "']");

                for (var j = 0; j < itemsPerSlide; j++) {
                    var item_pos = ((j) + (i * itemsPerSlide));
                    var $item = $parent.find('[data-calc-pos="' + item_pos + '"]');
                    if (!$item) break;
                    $item.css({"width": containerWidth / ColumnsPerSlide});
                    $col.append($item);
                }

                if (i >= $items.length) break;
            }
            ColumnsPerSlide = 1;
        }

        $carousel = $parent.owlCarouselV2({
            loop: false,
            margin: 10,
            nav: true,
            navText: ["előző", "következő"],
            autoHeight: true,
            responsiveClass: true,
            responsive: responsiveGrid,
            lazyLoad: true,
            mouseDrag: false,
            responsiveBaseElement: $parent.get(0)
        });

        $carousel.on("resize.owl.carousel", function (e) {
            refreshMatrixOnResize(e);
            refreshResponsiveGridByContentSize(ContentSize);
        });
    }

    function getGridCol(size, cW) {
        var gridIndex = 0;
        content_size_grid_matrix.grids.forEach(function (item, index) {
            if (item < cW)
                gridIndex = index;
            else return;
        });
        return content_size_grid_matrix[size][gridIndex];
    }

    function refreshResponsiveGridByContentSize(ContentSize) {
        $.each(responsiveGrid, function (index, grid) {
            var key, item;

            if (RowNumMax > 1) {
                responsiveGrid[index]["items"] = 1;
            } else {
                key = content_size_grid_matrix.grids.indexOf(index);
                if (key == -1) return;
                item = content_size_grid_matrix[ContentSize][key];
                responsiveGrid[index]["items"] = item;
            }
        });
    }

    function refreshMatrixOnResize(e) {
        RowNumMax = formatSettings && formatSettings.RowNumMax ? formatSettings.RowNumMax : 1;
        if (RowNumMax > 1) {
            containerWidth = $parent.parent().innerWidth();
            ColumnsPerSlide = getGridCol(ContentSize, containerWidth);
            itemsPerSlide = RowNumMax * ColumnsPerSlide;
            SlideNum = parseInt($items.length / itemsPerSlide);
            if (SlideNum < $items.length / itemsPerSlide) SlideNum++;

            // add slides if necessary
            if (e.item.count < SlideNum) {
                for (var i = e.item.count; i < SlideNum; i++) {
                    $carousel.trigger('add.owl.carousel', ['<div class="help-col" data-pos="' + i + '"></div>']);
                }
            }

            //slide refill
            for (var i = 0; i * itemsPerSlide < $items.length; i++) {
                var $col = $parent.find(".help-col[data-pos='" + i + "']");
                for (var j = 0; j < itemsPerSlide; j++) {
                    var item_pos = ((j) + (i * itemsPerSlide));
                    var $item = $parent.find('[data-calc-pos="' + item_pos + '"]');
                    if (!$item) break;
                    $item.css({"width": containerWidth / ColumnsPerSlide});
                    $col.append($item);
                }

                if (i >= $items.length) break;
            }

            // remove slides if necessary
            for (var i = e.item.count; i > SlideNum; i--) {
                $carousel.trigger('remove.owl.carousel', [i - 1]).trigger('refresh.owl.carousel');
            }

            ColumnsPerSlide = 1;
            $carousel.trigger('refresh.owl.carousel');
        }
    }
}